import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  autocomplete;

  static targets = [
    'streetAddress',
    'postalCode',
    'city',
    'province',
    'country',
  ];

  initialize() {
    this.initGoogleAutocomplete = this.initGoogleAutocomplete.bind(this);
    this.initPlaces = this.initPlaces.bind(this);
    this.searchPlace = this.searchPlace.bind(this);
    this.fillInAddress = this.fillInAddress.bind(this);
  }

  connect() {
    this.initPlaces();
  }

  initGoogleAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.streetAddressTarget);
  }

  initPlaces() {
    if (document.querySelector('[data-google-places]') === null) {
      const tag = document.createElement('script');
      tag.dataset.googlePlaces = 'true';

      tag.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAcr0vNCr-WA5SaAQbIW7HgGqbLAyZJmzw&libraries=places&callback=initAutocomplete';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.initAutocomplete = () => {
        this.initGoogleAutocomplete();
        this.searchPlace();
      };
    } else {
      this.initGoogleAutocomplete();
      this.searchPlace();
    }
  }

  searchPlace() {
    this.autocomplete = new google.maps.places.Autocomplete(this.streetAddressTarget, {
      fields: ['address_components', 'geometry', 'name'],
    });

    this.streetAddressTarget.focus();
    this.autocomplete.addListener('place_changed', this.fillInAddress);
  }

  /**
     *  This method attempts to take all permutations of how an address can be formed from
     *  the information we get from Google places and set that up as an address.
     *
     *  Reference: https://developers.google.com/maps/documentation/geocoding/requests-geocoding#Types
     */
  fillInAddress() {
    const place = this.autocomplete.getPlace();

    if (!place.geometry) {
      this.streetAddressTarget.value = '';
      this.cityTarget.value = '';
      this.provinceTarget.value = '';
      this.countryTarget.value = '';
      this.postalCodeTarget.value = '';

      return;
    }

    const address = place.address_components.reduce((acc, component) => {
      const types = component.types.reduce((acc, type) => {
        acc[type] = component.short_name;
        return acc;
      }, {});

      return { ...acc, ...types };
    }, {});

    this.streetAddressTarget.value = `${address.street_number || place.name || ''} ${address.route || ''}`;
    this.cityTarget.value = address.postal_town || address.locality;
    this.provinceTarget.value = address.administrative_area_level_1 || address.administrative_area_level_2 || '';
    this.countryTarget.value = address.country || address.political || '';
    this.postalCodeTarget.value = address.postal_code || '';
  }

  preventSubmit(event) {
    if (event.code === 'Enter') {
      event.preventDefault();
    }
  }
}
